import React from "react";
import {
	Box,
	Button,
	Typography
} from "@mui/material";
import ErrorIcon from "@mui/icons-material/Error";
import { Trans } from "@lingui/macro";

interface KeycloakErrorProps {
	details?: string | null;
}

export const KeycloakError = ({details}: KeycloakErrorProps) => {
	const reloadPage = () => window.location.reload();

	return (
		<Box textAlign="center" sx={{py: 6}}>
			<ErrorIcon color="error" sx={{fontSize: 48}} />
			<Typography variant="h4" sx={{mt: 2}}>
				<Trans id="kc-error-title">Errore di autenticazione</Trans>
			</Typography>
			<Typography variant="body1" sx={{mt: 2}}>
				<Trans id="kc-error-body">
					Non è stato possibile inizializzare Keycloak. Verifica la connessione o la configurazione dell'autenticazione e riprova.
				</Trans>
			</Typography>
			{details && <Typography variant="body2" color="text.secondary" sx={{mt: 1}}>
				{details}
			</Typography>}
			<Button variant="contained" color="primary" sx={{mt: 3}} onClick={reloadPage}>
				<Trans id="kc-error-retry">Riprova</Trans>
			</Button>
		</Box>
	);
};
